import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import DoctorInstructionQueuePage from '@pages/doctorInstructions/DoctorInstructionQueuePage';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const DoctorInstructionQueueRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('doctor-instruction-queue-page-title')}>
        <DoctorInstructionQueuePage />
      </PageWrapper>
    </Suspense>
  );
};

export default { DoctorInstructionQueueRoute };
